import { useEffect, useRef } from 'react';

import { AdObj, NativeAdObj } from '../../shared/types/ast';
import { isNative, isNativeVideoOrContent, isTakeover } from '../utils/ast';
import { events, messageBus } from '@schibsted-nmp/advertising-events';

/**
 * Sets styling for both placement and it's container.
 * The placement is usually rendered right after the call of this hook.
 * The container is rendered a completely different place in the DOM and needs to
 * be retrieved by ID.
 */
export function usePlacementStyling(
    placementId: string,
    containerId: string,
    adObj?: AdObj,
    status?: string,
) {
    const prevPublishedPayloadClassName = useRef<string>('');

    useEffect(() => {
        if (!adObj) return;
        const searchPlacement = placementId?.includes('board_');

        if (searchPlacement) {
            const adIsNative = isNative(adObj as NativeAdObj);
            const adIsContent = isNativeVideoOrContent(adObj);

            let className = '';

            if (searchPlacement) {
                if (adIsContent === 'video')
                    className = 'video-ad sf-advertising-video';
                else if (adIsContent === 'content')
                    className = 'content-ad sf-advertising-content';
                else if (adIsNative)
                    className = 'native-ad sf-advertising-native';
                else if (isTakeover(placementId, adObj as NativeAdObj)) {
                    className = 'takeover-ad sf-advertising-takeover';
                } else className = 'banner-ad sf-advertising-banner';
            }

            className =
                status === 'failed' ? ` hidden ${className}` : className;
            if (prevPublishedPayloadClassName.current === className) return;
            prevPublishedPayloadClassName.current = className;
            messageBus.publish(
                events.COMPANION.channel,
                events.COMPANION.AD_STYLES.topic,
                events.COMPANION.AD_STYLES.sendPayload({
                    className,
                    containerId: containerId || placementId + '--container',
                }),
            );
        }
    }, [status, containerId, adObj, placementId]);
}
